import React, { useState, useEffect } from 'react';
import { colors } from '../../config/constants';
import { ClickAwayListener } from '@mui/material';

type ItemProps = {
  name: string;
  value: string | boolean | null;
};
interface FilterProps {
  filterHandler: (arg: ItemProps) => void;
  rootFilter: ItemProps[];
  label?: string;
  heading?: string;
}

const Filter = (props: FilterProps) => {
  const { filterHandler, rootFilter, label, heading } = props;
  const [openDropdown, setOpenDropDown] = useState(false);
  const [resultValue, setResultValue] = useState<any>(label);

  const onSelectHandler = (item: ItemProps) => {
    setOpenDropDown(false);
    setResultValue(item.name);
    if (filterHandler) {
      filterHandler(item);
      setResultValue(item.name);
    }
  };

  useEffect(() => {
    setResultValue(label);
  }, [label]);

  return (
    <div
      data-testid="filter-wrapper"
      className={`relative cursor-pointer ${colors.primaryText}`}
    >
      <div
        className=" w-full sm:w-fit flex items-center border rounded-sm"
        onClick={() => setOpenDropDown(true)}
        data-testid="filter-result"
      >
        <div className="sm:w-[332px] w-full p-1  h-8 bg-white text-sm flex items-center justify-start pl-4 rounded-sm">
          {resultValue?.length < 30
            ? resultValue
            : `${resultValue?.substring(0, 29)}...`}
        </div>

        <div
          className={`h-8 w-8 flex items-center justify-center text-white ${colors.primary}`}
        >
          <i className="fa-solid fa-filter"></i>
        </div>
      </div>

      {openDropdown && (
        <ClickAwayListener onClickAway={() => setOpenDropDown(false)}>
          <div
            className={`absolute max-h-[332px] min-w-fit border overflow-auto sm:top-9 bg-white z-50 w-full shadow-lg rounded`}
          >
            <div className={`p-1 font-semibold h-fit ${colors.primaryText}`}>
              {heading}
            </div>
            {rootFilter.length > 0 ? (
              <>
                {rootFilter.map((item: ItemProps, index: number) => {
                  return (
                    <div
                      key={index}
                      data-testid={`filter-index-${index}`}
                      onClick={() => onSelectHandler(item)}
                      className={`hover:bg-sky-500 pl-2 mb-1 border-b hover:text-white  flex items-center  text-sm text-black pb-1`}
                    >
                      {item.name}
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="mb-2 text-sm text-black ">No records Found</div>
            )}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default Filter;
